import { FC } from 'react'
import { Loader2 } from 'lucide-react'

export const ForgotPasswordPending: FC = () => (
  <div className="inline-flex h-[384px] w-[450px] flex-col items-center justify-start gap-m overflow-hidden rounded-lg bg-white pb-m">
    <div className="relative flex h-xxl w-full flex-col rounded-t-lg border-b border-gray-200 bg-white">
      <div className="w-full pt-m text-center text-lg font-semibold leading-6 text-gray-700">
        Forgot password
      </div>
    </div>
    <div className="flex w-full max-w-[400px] flex-col items-center justify-start gap-m bg-white px-m">
      <div className="flex h-m w-full items-center justify-center">
        <p className="flex-1 text-center text-base font-medium leading-5 text-gray-500">
          Saving a new password...
        </p>
      </div>
      <Loader2
        className="animate-spin text-gray-400 opacity-40"
        size={24}
        strokeWidth={2}
      />
    </div>
  </div>
)
